export default "https://cdn-static.gokick.com/assets/45a1ec4753cb63ac9804059da02cc099817f84d7/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";